module.exports = __webpack_public_path__ + "img/p2.8ae0dc01.png";